export default __webpack_public_path__ + "static/media/jest.f250d0be.png";